import { createAction, props } from "@ngrx/store";
import type { CalendarEvent } from "./calendar.models";

export const CalendarEventsFetchRequest = createAction(
  '[Calendar] Events Fetch Request',
  props<{ start: string; end: string }>()
);

export const CalendarEventsFetchSuccess = createAction(
  '[Calendar] Events Fetch Success',
  props<{ start: string; end: string; events: CalendarEvent[] }>()
);

export const CalendarEventsFetchFailure = createAction(
  '[Calendar] Events Fetch Failure',
  props<{ error: string }>()
);

export const CalendarEventCreateRequest = createAction(
  '[Calendar] Event Create Request',
  props<{
    payload: {
      event_type: 'in_person' | 'online';
      title: string;
      description?: string;
      location?: string;
      start_at: string;
      end_at: string;
      all_day: boolean;
      attendee_user_ids?: string[];
      attendee_emails?: string[];
      attendee_external?: Array<{ name: string; email: string }>;
      recurrence_frequency?: string;
      recurrence_interval?: number;
      recurrence_until?: string;
    };
    attachMeetrixLink?: boolean;
  }>()
);

export const CalendarEventCreateSuccess = createAction(
  '[Calendar] Event Create Success',
  props<{ event: CalendarEvent }>()
);

export const CalendarEventCreateFailure = createAction(
  '[Calendar] Event Create Failure',
  props<{ error: string }>()
);

export const CalendarEventUpdateRequest = createAction(
  '[Calendar] Event Update Request',
  props<{
    eventId: string;
    payload: {
      event_type?: 'in_person' | 'online';
      title?: string;
      description?: string;
      location?: string;
      start_at?: string;
      end_at?: string;
      all_day?: boolean;
      attendee_user_ids?: string[];
      attendee_emails?: string[];
      attendee_external?: Array<{ name: string; email: string }>;
      recurrence_frequency?: string;
      recurrence_interval?: number;
      recurrence_until?: string;
    };
    attachMeetrixLink?: boolean;
  }>()
);

export const CalendarEventUpdateSuccess = createAction(
  '[Calendar] Event Update Success',
  props<{ event: CalendarEvent }>()
);

export const CalendarEventUpdateFailure = createAction(
  '[Calendar] Event Update Failure',
  props<{ error: string }>()
);

export const CalendarEventDeleteRequest = createAction(
  '[Calendar] Event Delete Request',
  props<{ eventId: string }>()
);

export const CalendarEventDeleteSuccess = createAction(
  '[Calendar] Event Delete Success',
  props<{ eventId: string }>()
);

export const CalendarEventDeleteFailure = createAction(
  '[Calendar] Event Delete Failure',
  props<{ error: string }>()
);

export const CalendarEventJoinRequest = createAction(
  '[Calendar] Event Join Request',
  props<{ eventId: string }>()
);

export const CalendarEventJoinSuccess = createAction(
  '[Calendar] Event Join Success',
  props<{ payload : any }>()
);

export const CalendarEventJoinFailure = createAction(
  '[Calendar] Event Join Failure',
  props<{ error: string }>()
);

export const CalendarEventExternalLinkRequest = createAction(
  '[Calendar] Event External Link Request',
  props<{ token: string }>()
);

export const CalendarEventExternalLinkSuccess = createAction(
  '[Calendar] Event External Link Success',
  props<{ payload : any }>()
);

export const CalendarEventExternalLinkFailure = createAction(
  '[Calendar] Event External Link Failure',
  props<{ error: string }>()
);

export const CalendarInviteParticipantRequest = createAction(
  '[Calendar] Invite Participant Request',
  props<{ eventId: string; email: string, name?: string }>()
);

export const CalendarInviteParticipantSuccess = createAction(
  '[Calendar] Invite Participant Success',
  props<{ payload:any }>()
);

export const CalendarInviteParticipantFailure = createAction(
  '[Calendar] Invite Participant Failure',
  props<{ error: string }>()
);
